import React from 'react';

const StorZebraSettings = React.memo(({
  activeTypeTab,
  storExtras,
  setStorExtras,
  zebraExtras,
  setZebraExtras,
  handleSaveSettings,
  isSavingSettings
}) => {
  const isStor = activeTypeTab === 'stor';
  const extras = isStor ? storExtras : zebraExtras;
  const setExtras = isStor ? setStorExtras : setZebraExtras;

  return (
    <>
      <div className="settings-card" style={{ marginBottom: '20px' }}>
        <div className="settings-card-title">
          <i className="fas fa-cogs"></i>
          <h4>Motor Ayarları</h4>
          <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings}>
            {isSavingSettings ? '...' : 'Kaydet'}
          </button>
        </div>
        <div className="settings-grid">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Motor Döviz Kuru</label>
            <select value={extras.motorCurrency} onChange={(e) => setExtras(p => ({ ...p, motorCurrency: e.target.value }))}>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="TRY">TRY</option>
            </select>
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Motor Ücreti</label>
            <input type="number" value={extras.motorPrice} onChange={(e) => setExtras(p => ({ ...p, motorPrice: e.target.value }))} />
          </div>
        </div>
      </div>

      <div className="settings-card" style={{ marginBottom: '20px' }}>
        <div className="settings-card-title">
          <i className={isStor ? "fas fa-cog" : "fas fa-stream"}></i>
          <h4>{isStor ? "Stor" : "Zebra"} Perde Ücret Ayarları (₺)</h4>
          <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings}>
            {isSavingSettings ? '...' : 'Kaydet'}
          </button>
        </div>
        <div className="settings-grid">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Jumbo Sistem</label>
            <input type="number" value={extras.jumbo} onChange={(e) => setExtras(p => ({ ...p, jumbo: e.target.value }))} />
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Alt Etek Dilim</label>
            <input type="number" value={extras.altEtekDilim} onChange={(e) => setExtras(p => ({ ...p, altEtekDilim: e.target.value }))} />
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Kapalı Kasa</label>
            <input 
              type="number" 
              value={isStor ? extras.kapaliKasa : extras.zebraKapaliKasa} 
              onChange={(e) => setExtras(p => ({ ...p, [isStor ? 'kapaliKasa' : 'zebraKapaliKasa']: e.target.value }))} 
            />
          </div>
          {isStor && (
            <>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Alt Etek Lazer</label>
                <input type="number" value={extras.altEtekLazer} onChange={(e) => setExtras(p => ({ ...p, altEtekLazer: e.target.value }))} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Dekoratif Lama</label>
                <input type="number" value={extras.dekoratifLama} onChange={(e) => setExtras(p => ({ ...p, dekoratifLama: e.target.value }))} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Dekoratif Kasa</label>
                <input type="number" value={extras.dekoratifKasa} onChange={(e) => setExtras(p => ({ ...p, dekoratifKasa: e.target.value }))} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Alt Etek Beyaz İş</label>
                <input type="number" value={extras.altEtekBeyazIs} onChange={(e) => setExtras(p => ({ ...p, altEtekBeyazIs: e.target.value }))} />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
});

export default StorZebraSettings;
